import { IControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { spFolderItemSetKeyFacet } from '../../../dataSource/Keys';
import { filteredItemSetControl } from '@ms/items-view/lib/private/controls/filteredItemSetControl';
import { createControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import { IItemCacheThunkAction, IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { itemFolderTypeFilterHandler, itemPhotoTypeFilterHandler, itemVideoTypeFilterHandler }
  from '@ms/items-view/lib/private/models/itemSets/filters/itemTypeFilterHandler';
import { getExtensionFromFilterHandler } from '@ms/items-view/lib/private/models/itemSets/filters/itemExtensionFilterHandler';

export const spFolderItemSetFilteredItemSetControlHandler: IControlHandler<
  typeof spFolderItemSetKeyFacet.type,
  typeof filteredItemSetControl.type
> = createControlHandler()(getFilteredItemSetControlHandler);

function getFilteredItemSetControlHandler(): IItemCacheThunkAction<typeof filteredItemSetControl.type> {
  return (dispatch: IItemCacheDispatch): typeof filteredItemSetControl.type => {
    return (itemCache: IItemCache, props: typeof filteredItemSetControl.inputType): typeof filteredItemSetControl.returnType => {
      const {
        itemKey,
        handlers
      } = props;

      const spFolderItemSet = itemCache.demandItemFacet(spFolderItemSetKeyFacet, itemKey);

      if (spFolderItemSet) {
        const extFilters: string[] = [];

        for (const handler of handlers) {
          if (handler.key === itemFolderTypeFilterHandler.key) {
            extFilters.push('folder');
          } else if (handler.key === itemPhotoTypeFilterHandler.key) {
            extFilters.push('photo');
          } else if (handler.key === itemVideoTypeFilterHandler.key) {
            extFilters.push('video');
          } else {
            const extension = getExtensionFromFilterHandler(handler);

            if (extension) {
              extFilters.push(extension);
            }
          }
        }

        if (extFilters.length > 0) {
          return {
            itemKey: spFolderItemSetKeyFacet.serialize({
              ...spFolderItemSet,
              extFilters
            })
          };
        }
      }

      return {};
    };
  };
}
